import { styled } from '@mui/material';

export const PageW = styled('div')`
  padding-left: 38px;
  padding-top: 64px;
  @media (max-width: 1023px) {
    margin-top: 88px;
    padding: 16px 16px 96px 16px;
  }
`;

export const PageHeaderW = styled('div')`
  width: 100%;
  max-width: 671px;
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  align-self: flex-start;
  @media (max-width: 1023px) {
    margin-bottom: 16px;
    max-width: unset;
  }
`;

export const ContentW = styled('div')`
  width: 100%;
  justify-content: center;
  display: flex;
  align-items: flex-start;
`;
